export enum apiStrings {
  _ = "",
  NOT_APPLICABLE = "not_applicable",
  NOT_YET_AVAILABLE = "not_yet_available",
}
